<template>
  <div class="mt-3">
    <b-button
      variant="gray"
      class="f-110 back-to-top-circle py-0"
      v-if="isVisible"
      @click="backToTop"
    >
      <fa icon="angle-up"></fa>
    </b-button>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        position: { y: 0 },
      };
    },
    computed: {
      isVisible: {
        get() {
          return this.position.y / document.body.scrollHeight > 0.2;
        },
      },
    },
    methods: {
      backToTop() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      },
    },
    created() {
      if (!this.$isServer) {
        this._scrollListener = () => {
          this.position = {
            y: Math.round(window.pageYOffset),
          };
        };
        this._scrollListener();
        window.addEventListener('scroll', this._scrollListener);
      }
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this._scrollListener);
    },
  };
</script>

<style scoped>
  .back-to-top-circle {
    width: 34px;
    height: 34px;
  }
</style>
